import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonServices } from './core/services/common.services';
import { LanguageService } from './core/services/language.service';
import { SharedModule } from './shared/shared.module';

@Component({
  selector: 'app-root',
  imports: [RouterModule, SharedModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {


  constructor(
    private commonServices: CommonServices,
    // Se inyecta para inicializar el idioma (persistido/navegador) desde el arranque.
    private languageService: LanguageService
  ) {}
  
  ngOnInit() {
    this.commonServices.loadCountries();
  }
  

}